import { COLORS } from "@/lib/theme";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{
        background: "#2a1830",
        color: "rgba(255,255,255,0.85)",
        padding: "40px 32px 30px",
        marginTop: 0,
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 32 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
            <img src="/assets/linkshul-logo.png" alt="LinkShul" style={{ height: 44, borderRadius: 8 }} />
            <span className="font-heading" style={{ fontWeight: 800, fontSize: 22, color: "#fff" }}>
              Link<span style={{ color: COLORS.goldLight }}>shul</span>
            </span>
          </div>
          <div style={{ fontSize: 13, lineHeight: 1.6, opacity: 0.75 }}>
            LinkShul — a warm, united and dynamic Orthodox community in the eastern suburbs of Johannesburg.
          </div>
        </div>

        <div>
          <div className="font-heading" style={{ fontWeight: 800, fontSize: 15, color: COLORS.goldLight, marginBottom: 12, letterSpacing: 0.3 }}>
            OFFICE
          </div>
          <div style={{ fontSize: 13.5, lineHeight: 1.9 }}>
            <div><a href="mailto:admin@linkshul.co.za" style={{ color: "#fff", textDecoration: "none" }}>admin@linkshul.co.za</a></div>
            <div><a href="mailto:office@linkshul.co.za" style={{ color: "#fff", textDecoration: "none" }}>office@linkshul.co.za</a></div>
            <div><a href="mailto:operations@linkshul.co.za" style={{ color: "#fff", textDecoration: "none" }}>operations@linkshul.co.za</a></div>
            <div><a href="mailto:leviavtzon@gmail.com" style={{ color: "#fff", textDecoration: "none" }}>leviavtzon@gmail.com</a></div>
            <div><a href="tel:+27116405812" style={{ color: "#fff", textDecoration: "none" }}>011 640 5812</a></div>
          </div>
        </div>

        <div>
          <div className="font-heading" style={{ fontWeight: 800, fontSize: 15, color: COLORS.goldLight, marginBottom: 12, letterSpacing: 0.3 }}>
            MIKVAH RACHEL
          </div>
          <div style={{ fontSize: 13.5, lineHeight: 1.9 }}>
            <a href="tel:+27760931927" style={{ color: "#fff", textDecoration: "none" }}>076 093 1927</a>
          </div>
        </div>

        <div>
          <div className="font-heading" style={{ fontWeight: 800, fontSize: 15, color: COLORS.goldLight, marginBottom: 12, letterSpacing: 0.3 }}>
            WEBSITE
          </div>
          <div style={{ fontSize: 13.5, lineHeight: 1.9 }}>
            <a href="https://www.linkshul.co.za" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "none" }}>
              www.linkshul.co.za
            </a>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: "32px auto 0", paddingTop: 20, borderTop: "1px solid rgba(255,255,255,0.15)", textAlign: "center", fontSize: 12, opacity: 0.7, lineHeight: 1.8 }}>
        <div>© LinkShul. All Rights Reserved.</div>
        <div>Powered by Farrell Berson</div>
      </div>
    </footer>
  );
}
